import React from "react";
import "./FlexibleDateStrip.css";

export default function FlexibleDateStrip({ days, onSelectDay, onShiftDays }) {
  if (!days?.length) return null;
  return (
    <section className="fe2-dates" aria-label="תאריכים גמישים">
      <button
        type="button"
        className="fe2-dates__arrow"
        aria-label="ימים קודמים"
        onClick={() => onShiftDays?.("prev")}
      >
        ›
      </button>
      <ul className="fe2-dates__list">
        {days.map((day) => {
          const cls = [
            "fe2-dates__cell",
            day.selected ? "fe2-dates__cell--selected" : "",
            day.cheapest ? "fe2-dates__cell--cheapest" : "",
          ]
            .filter(Boolean)
            .join(" ");
          return (
            <li key={day.id}>
              <button
                type="button"
                className={cls}
                onClick={() => onSelectDay?.(day)}
              >
                <span className="fe2-dates__weekday">{day.weekday}</span>
                <span className="fe2-dates__date fe2-ltr">{day.dateLabel}</span>
                <span className="fe2-dates__price fe2-ltr">{day.priceLabel}</span>
                {day.cheapest ? (
                  <span className="fe2-dates__cheap-badge">הכי זול</span>
                ) : null}
              </button>
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        className="fe2-dates__arrow"
        aria-label="ימים הבאים"
        onClick={() => onShiftDays?.("next")}
      >
        ‹
      </button>
    </section>
  );
}
